import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';

import Layout from './hoc/Layout/Layout';
import Application from './containers/Application/Application';
import UserProfile from './containers/UserProfile/UserProfile';
import SignIn from './containers/SignIn/SignIn';
import SignUp from './containers/SignUp/SignUp';
import AutoSignIn from './containers/AutoSignIn/AutoSignIn';
import Activation from './containers/Activation/Activation';
import SignUpCompleted from './components/SignUpCompleted/SignUpCompleted';
import BuyProduct from './containers/BuyProduct/BuyProduct';
import PaymentMethod from './containers/PaymentMethod/PaymentMethod';
import TransactionCompleted from './containers/TransactionCompleted/TransactionCompleted';
import Dashboard from './containers/protected/Dashboard/Dashboard';
import Logout from './containers/Logout/Logout';
import MyTrainings from './containers/protected/MyTrainings/MyTrainings';
import Training from './containers/protected/Training/Training';
import Transactions from './containers/protected/Transactions/Transactions';
import TrainingChapter from './containers/protected/TrainingChapter/TrainingChapter';
import Products from './containers/protected/Products/Products';
import Metronome from './containers/protected/Metronome/Metronome';
import MyTools from './containers/protected/MyTools/MyTools';
import Faq from './containers/protected/Faq/Faq';
import CheckSong from './containers/protected/CheckSong/CheckSong';
import SendPasswordResetMail from './containers/SendPasswordResetMail/SendPasswordResetMail';
import ResetPassword from './containers/ResetPassword/ResetPassword';
import TransactionOptions from './containers/protected/TransactionOptions/TransactionOptions';
import StudentSamples from './containers/protected/StudentSamples/StudentSamples';
import StudentSongs from './containers/protected/StudentSongs/StudentSongs';
import StudentVerifications from './containers/protected/StudentVerifications/StudentVerifications';
import Survey from './containers/Survey/Survey';
import AvailableUpgrades from './containers/protected/AvailableUpgrades/AvailableUpgrades';
import Message from './containers/protected/Message/Message';
import Messages from './containers/protected/Messages/Messages';
import AddToHomescreen from 'react-add-to-homescreen';
import LandingPage01 from './containers/LandingPage/LandingPage01';
import OptInCompleted from './containers/OptIn/OptInCompleted';
import SPSOptInCompleted from './containers/OptIn/SPSOptInCompleted';
import ProductWorkouts from './containers/protected/Workout/ProductWorkouts';
import Workout from './containers/protected/Workout/Workout';
import LPPersonalApproach from './containers/LandingPage/LPPersonalApproach';
import Articles from './containers/LandingPage/Articles';

class App extends Component {

  componentWillMount() {
    if (localStorage.getItem("expirationDate") != null && new Date() >= new Date(localStorage.getItem("expirationDate"))) {
      localStorage.clear();
      this.props.history.replace('/signin');
    }
  }

  handleAddToHomescreenClick = () => {
    alert('1. Open Share menu, 2. Tap on "Add to Home Screen" button');
  };

  render() {
    return (
      <div>
        <Layout>
          <Route path="/protected/profile" component={UserProfile} />
          <Route path="/protected/dashboard" component={Dashboard} />
          <Route path="/protected/product-workouts/:transactionCode" exact component={ProductWorkouts} />
          <Route path="/protected/products" component={Products} />
          <Route path="/protected/my-trainings" component={MyTrainings} />
          <Route path="/protected/training/:transactionCode" exact component={Training} />
          <Route path="/protected/workout/:transactionCode" exact component={Training} />
          <Route path="/protected/training/:transactionCode/options" exact component={TransactionOptions} />
          <Route path="/protected/training/:trainingCode/chapter/:chapterCode" exact component={TrainingChapter} />
          <Route path="/protected/training/:productCode/upgrades" exact component={AvailableUpgrades} />
          <Route path="/protected/transactions" exact component={Transactions} />
          <Route path="/protected/samples" exact component={StudentSamples} />
          <Route path="/protected/songs" exact component={StudentSongs} />
          <Route path="/protected/verifications" exact component={StudentVerifications} />
          <Route path="/protected/messages" exact component={Messages} />
          <Route path="/protected/faq" exact component={Faq} />
          <Route path="/protected/check-song/:transactionCode" exact component={CheckSong} />
          <Route path="/protected/materials/:materialCode/message" exact component={Message} />
          <Route path="/protected/workouts/:transactionCode/:workoutCode" exact component={Workout} />
          <Route path="/signup" component={SignUp} />
          <Route path="/signin" component={SignIn} />
          <Route path="/auto-signin" component={AutoSignIn} />
          <Route path="/survey" component={Survey} />
          <Route path="/signup-completed" component={SignUpCompleted} />
          <Route path="/sps-optin-completed" component={SPSOptInCompleted} />
          <Route path="/optin-completed" component={OptInCompleted} />
          <Route path="/activate/:code" component={Activation} />
          <Route path="/buy-product/:code" component={BuyProduct} />
          <Route path="/transaction-completed" component={TransactionCompleted} />
          <Route path="/payment-method/:transactionCode/:method" component={PaymentMethod} />
          <Route path="/logout" component={Logout} />
          <Route path="/reset-password" exact component={SendPasswordResetMail} />
          <Route path="/personal_lp" exact component={LPPersonalApproach} />
          <Route path="/articles" exact component={Articles} />
          <Route path="/_lp" exact component={LandingPage01} />
          <Route path="/reset-password/:changePasswordCode" component={ResetPassword} />
          <Route path="/protected/metronome" component={Metronome} />
          <Route path="/protected/my-tools" component={MyTools} />
          <Route path="/" exact component={Application} />
        </Layout>
        <AddToHomescreen onAddToHomescreenClick={this.handleAddToHomescreenClick} />
      </div>
    );
  }
}

export default withRouter(App);
